import React, { useEffect, useMemo, useState, FC, ReactElement } from "react";
import { Form, Button, Card, Divider, Confirm, List } from "semantic-ui-react";
import {
  useForm,
  usePromise,
  formatDropdownOptions,
  downloadUrl,
  MethodTypes,
  IHandleSubmitOptions,
  convertBoolToText,
  getMaskedString,
  getDropdownSemanticOption,
  downloadFile,
  removeTimestamp,
  addTimestamp,
  navigateToUrl,
  appendParam,
  getFieldHasValidation,
  getFormattedMinMaxDate,
  appendIdToPath,
  IDownloadOptions
} from "../../../helpers/GlobalHelper";
import LMSFormInput from "./LmsFormInput";
import LmsMessage from "./LmsMessage";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { convertToCamelCase } from "../../../helpers/GlobalHelper";
import { addAddressFields, addPhysicalAddressFields, addMailingAddressFields, addMailingIsSameAsPhysicalField } from "./LmsSharedForms";
import { InputFieldTypes, FieldTypes, WidthType, ModalSizesType, IFormErrorMessage, ButtonSizesType } from "../../interfaces/Global";
import { isGuid } from "../../../Helpers";
import "../../../styles/lms/lms-global.scss";
import BCErrorBoundary from "../../BCErrorBoundary";
import BCModal from "../../ui/BCModal";
import { FeatureFlags } from "../../constants/LocalServerConstants";

type PositionType = "left-center" | "center" | "right-center" | "top-left" | "top-center" | "top-right";
export type ValidationFunctionType = (options: any) => any;
export type ValidationOptionsType = "required" | "zipcode" | "email" | "website" | "phone" | "EIN/TIN" | "abbreviation" | "routingNumber" | "confirmPassword" | "socialSecurityNumber" | "positiveNumber" | "custom" | "amendment";
export type ValidationFunctionObjectType = Record<string, ValidationFunctionType>;
export type ValidationsObjetType = Record<string, (ValidationOptionsType | ValidationFunctionObjectType | Record<string, any> | Record<string, Record<string, any>>)[]>;

interface IDropdownOption {
  key: string;
  text: string;
  value: string;
}

type DropdownOptionsAPISuffix = string;
type ActionRedirectUrlType = string
type LmsInputFieldTypes = InputFieldTypes | "label" | "link" | "button" | "buttonsGroup";
type LmsFormFieldButtonRenderType = "button" | "link"
export type IsHiddenDisabledOperationTypes = "equal" | "notequal" | "isUndefined" | "isFalsy" | "includes" | "doesNotInclude" | "isEditOnly" | "isMailingSameAsPhysical";
export type IsHiddenOrDisabledFuncType = (options: any) => boolean | undefined;
export type ModalContentType = (setIsAddFormModalOpen: any,  options?: any) => ReactElement;

interface IResponseData {
  data: any;
  error: any;
}

export type DropdownOptionsTypes = IDropdownOption[] | Promise<IResponseData> | DropdownOptionsAPISuffix;
export type SemanticUIDropdownOptionsType = IDropdownOption[];

interface IDropdownQueries {
  query: string;
  fieldName: string;
}

export type AddressFieldTypes = "city" | "state" | "county";
type LabelFuncType = (options: any, fieldOptions: any) => string | undefined | null;

export interface IFormGeneratorFieldOptions {
  name?: string,
  label?: string,
  labelWarningText?: string,
  errorLabel?: string,
  warningFieldText?: string,
  labelFunc?: LabelFuncType,
  value?: string | number | boolean | string[],
  defaultValue?: string | number | boolean | string[],
  field?: LmsInputFieldTypes,
  fieldType?: FieldTypes,
  nestedInputsProp?: number | string
  addressFieldType?: AddressFieldTypes
  unitType?: string,
  radioValue?: string,
  placeHolder?: string,
  maskedValue?: any
  inline?: boolean,
  inlineRight?: boolean,
  checkboxText?: string,
  disabled?: boolean,
  isEnabled?: boolean,
  width?: WidthType
  fieldLabelClassName?: string
  fieldClassName?: string
  position?: PositionType,
  dropdownOptions?: DropdownOptionsTypes;
  dropdownListKey?: string,
  dropdownMultiple?: boolean,
  dependencyField?: string,
  dependencyFieldQuery?: string,
  optionalDropdownQueries?: IDropdownQueries[],
  dropdownOptionsSubPath?: string,
  dropdownOptionsIsPromiseAll?: boolean,
  dropdownSkipCache?: boolean;
  required?: boolean | Record<string, any>
  validations?: (ValidationOptionsType | ValidationFunctionObjectType)[]
  isHidden?: Record<string, any>
  isHiddenOperation?: IsHiddenDisabledOperationTypes,
  isHiddenFunc?: IsHiddenOrDisabledFuncType,
  keepHiddenPosition?: boolean,
  isDisabledOn?: Record<string, any>
  isDisabledOnOperation?: IsHiddenDisabledOperationTypes
  isDisabledOnFunc?: IsHiddenOrDisabledFuncType,
  calculatedFields?: string[]
  calculatedFunc?: (inputs?: any, options?: any) => any
  calculatedType?: "number" | "string"
  calculatedTargetField?: string
  onChange?: (options?: any) => any
  onFieldChanged?: (options?: any) => any
  charLimit?: number
  maxPercentage?: number | string
  maxValue?: number
  decimalsLimit?: number
  allowNegativeValue?: boolean
  tableName?: string
  tableValueName?: string
  inlineEdit?: boolean
  onButtonClick?: ((any) => any) | string
  buttonIcon?: string
  alignRight?: boolean
  alignLeft?: boolean
  fullWidth?: boolean
  component?: any
  noBackground?: boolean
  fontWeightLight?: boolean
  actionFunc?: (options?: any) => void,
  actionPath?: ActionRedirectUrlType,
  actionLabel?: string
  actionIcon?: string
  isActionEnabled?: boolean
  removeActionFunc?: (options?: any) => void,
  removeActionLabel?: string
  removeActionIcon?: string
  displayRemoveButton?: boolean
  actionHasDependency?: boolean
  isActionHiddenOnDisabled?: boolean
  onDisabledLabel?: string
  buttonRenderType?: LmsFormFieldButtonRenderType
  buttonsGroup?: IFormGeneratorFieldOptions[]
  buttonDownloadMethod?: "GET" | "POST"
  modalContent?: ModalContentType
  modalSize?: ModalSizesType
  documentDownloadSuffix?: string
  documentFileName?: string
  uploadDocSuffix?: string;
  fileFieldName?: string;
  textAlignRight?: boolean;
  labelColor?: "red"
  valueColor?: "red"
  fontSize?: string
  fontWeight?: number
  wrapLabel?: boolean
  wrapText?: boolean
  mailingAddressMapping?: string
  isDefaultDateNow?: boolean
  isCompact?: boolean,
  minDate?: string | Date | number
  maxDate?: string | Date | number
  skipClearable?: boolean
  clearable?: boolean;
}

interface IFormGeneratorActionFieldOptions {
  actionFunc?: (options?: any) => void,
  actionPath?: ActionRedirectUrlType,
  actionLabel?: string
  actionIcon?: string
  removeActionFunc?: (options?: any) => void,
  removeActionLabel?: string
  removeActionIcon?: string
}

interface IGroupFieldsOptions {
  widths?: WidthType,
  inlineGroup?: boolean,
  groupLabel?: string
  radioGroupValue?: string,
  radioGroupName?: string,
  groupClassName?: string,
  isCentered?: boolean,
  blankWidth?: WidthType,
  isHidden?: Record<string, any>
  isDisabled?: Record<string, any>
  isHiddenOperation?: IsHiddenDisabledOperationTypes
  isDisabledOnOperation?: IsHiddenDisabledOperationTypes
  isHiddenFunc?: IsHiddenOrDisabledFuncType
  nestedInputsProp?: string | number
  groupStyles?: Record<string, any>
  isCompact?: boolean
}

type OnSubmitSuccessFuncType = (response?: any, options?: any) => any;
type OnSaveContinueFuncType = (response?: any, options?: any) => any;
type SubmitSuffixFuncType = (options?: any) => string;
export type OnDropdownOptionsLoadedFuncType = (dropdownOptionsDataArrays: Record<string, any>, options?: any) => any;
export type PayloadContentType = "JSON" | "FormData"
type SubmitConfirmationMessageFuncType = (options?: any) => string;

export interface IBCFormControllerOptions {
  formLabel?: string,
  centeredTitle?: string,
  groupClassName?: string,
  formClassName?: string,
  formLabelClassName?: string,
  fieldLabelClassName?: string,
  fieldClassName?: string,
  skipPlaceHolder?: boolean,
  validations?: ValidationsObjetType,
  errors?: Record<string, any>,
  dataFormatterFunc?: any,
  initIsDisabled?: boolean,
  recordId?: string,
  calculatedFields?: ICalculatedFieldsOptions,
  calculatedTargetFields?: ICalculatedFieldsOptions,
  widths?: WidthType,
  blankWidth?: WidthType
  centeredFieldWidth?: WidthType
  submitSuffix?: string | ((options?: any) => string),
  submitConfirmationMessage?: string | SubmitConfirmationMessageFuncType
  submitAlertMessage?: string | SubmitConfirmationMessageFuncType
  deleteSuffix?: string
  saveAndContinueSuffix?: string
  submitMethod?: MethodTypes
  payloadDataType?: PayloadContentType
  spreadFormDataArrays?: boolean;
  clearSuffixesOnSubmit?: string[]
  exitEditOnClose?: boolean
  noBorder?: boolean
  onFormChange?: any
  isDebug?: boolean,
  errorTitle?: string
  errorTitleClassName?: string
  values?: Record<string, any>
  displayValues?: Record<string, any>
  metaData?: Record<any, any>
  maskedValues?: Record<string, any>
  initFileDownloads?: Record<string, any>
  onSubmitSuccess?: OnSubmitSuccessFuncType
  onSubmitSuccessMessage?: string
  successMessageFormatterFunc?: any
  skipAutoCloseSuccessMessage?: string
  onSaveContinue?: OnSaveContinueFuncType
  dropdownOptionsDataArrays?: Record<string, any>
  onDropdownOptionsLoaded?: OnDropdownOptionsLoadedFuncType;
  allDropdownOptionsAreReady?: boolean
  displayMessageLocally?: boolean
  uploadDocSuffix?: string
  excludeFromSubmit?: string[]
  isCompact?: boolean
  addressFields?: Record<string, any>
  mailingIsSameAsPhysicalFieldName?: string
  styles?: IFormStyles
  groupStyles?: Record<string, any>
  hiddenFields?: Record<string, any>
  disabledFields?: Record<string, any>
}

interface IFormGeneratorLabelFieldOptions extends IFormGeneratorFieldOptions {
  width?: WidthType
  position?: PositionType
  fieldLabelClassName?: string
  fieldClassName?: string
}

type LinkTypes = "Download" | "DownloadFile" | "Navigate" | "Link"
type ListItemTypes = "Text" | "Link"

interface IFormLinkFieldOptions extends IFormGeneratorFieldOptions {
  link: string
  linkName?: string
  linkType?: LinkTypes
  method?: MethodTypes
}

interface IListOption {
  text?: string
  link?: string
  linkName?: string
  listItemIcon?: string
  contentComponent?: FC<any>
}

interface IFormListFieldOptions {
  listItemType?: ListItemTypes
  linkType?: LinkTypes
  downloadMethod?: MethodTypes
  listOptions?: string[] | IListOption[]
  listItemIcon?: string
  handleClick?: (options: any) => any;
}

interface IFormGeneratorBlankFieldOptions {
  width?: WidthType
}

export interface ICalculatedFieldsOptions {
  type: "string" | "number"
  valueField: string
  calculatedFieldsNames: string[]
  calculatedFunction: (any) => any
}

export interface ITriggerField {
  name: string
  nestedInputsProp: string | number
  targetField: string
}

export interface IFormStyles {
  minWidth?: string
  width?: string
  minHeight?: string
}

const getValues = (values = {}, id) => {
  if (id) {
    return { ...values, id };
  }
  else {
    return { ...values };
  }
};

export class BCFormController {
  values: any;
  initialValues: any;
  metaData: Record<any, any>;
  excludeFromSubmit?: string[];
  initFileDownloads?: Record<string, any>;
  validations: ValidationsObjetType;
  errors: Record<string, any>;
  dataFormatterFunc?: any;
  fields: any[] = [];
  className: string;
  groupClassName: string;
  labelClassName: string;
  label: string;
  centeredTitle?: string;
  fieldLabelClassName: string;
  fieldClassName: string;
  skipPlaceHolder: boolean;
  initIsDisabled: boolean;
  recordId: string;
  calculatedFields: ICalculatedFieldsOptions;
  calculatedTargetFields: Record<string, any>;
  calculatedTriggerFields?: ITriggerField[];
  numberFields = [] as any[];
  widths: WidthType;
  blankWidth: WidthType;
  submitSuffix: string | SubmitSuffixFuncType;
  submitConfirmationMessage?: string | SubmitConfirmationMessageFuncType
  submitAlertMessage?: string | SubmitConfirmationMessageFuncType
  deleteSuffix: string;
  saveAndContinueSuffix: string;
  uploadDocSuffix: string;
  submitMethod: MethodTypes;
  payloadDataType: PayloadContentType;
  clearSuffixesOnSubmit?: string[];
  exitEditOnClose?: boolean;
  hiddenFields?: Record<string, any>;
  hiddenFieldsRules: Record<string, any> = {}
  disabledFields?: Record<string, any>;
  disabledFieldsRules: Record<string, any> = {}
  displayValues: Record<string, any>
  maskedValues: Record<string, any>
  addressFields: Record<string, any>
  mailingIsSameAsPhysicalFieldName: string
  allDropdownOptions: any = [] as any[]
  dropdownOptionsDataArrays: Record<string, any>
  onDropdownOptionsLoaded?: OnDropdownOptionsLoadedFuncType;
  allDropdownOptionsAreReady?: boolean
  noBorder: boolean;
  onFormChange?: any;
  isDebug?: boolean
  errorTitle?: string
  errorTitleClassName?: string
  onSubmitSuccess?: OnSubmitSuccessFuncType
  onSubmitSuccessMessage?: string
  successMessageFormatterFunc?: any
  skipAutoCloseSuccessMessage?: string
  onSaveContinue?: OnSaveContinueFuncType
  displayMessageLocally?: boolean
  isCompact?: boolean
  styles: IFormStyles
  groupStyles: Record<string, any>
  constructor(
    initialValues: any = {},
    options: IBCFormControllerOptions = {}
  ) {
    this.values = getValues(options.values, initialValues?.id || options.recordId);
    this.initialValues = { ...initialValues };
    this.displayValues = options.displayValues || {};
    this.metaData = { ...options.metaData };
    this.maskedValues = options.maskedValues || {};
    this.excludeFromSubmit = options.excludeFromSubmit;
    this.initFileDownloads = options.initFileDownloads;
    this.dataFormatterFunc = options.dataFormatterFunc;
    this.className = options.formClassName || "lms-form-generator-container";
    this.groupClassName = options.groupClassName || "lms-form-generator-group-container";
    this.labelClassName = options.formLabelClassName || "lms-form-generator-container-label";
    this.label = options.formLabel || "";
    this.centeredTitle = options.centeredTitle || "";
    this.fieldLabelClassName = options.fieldLabelClassName || "";
    this.fieldClassName = options.fieldClassName || "lms-disabled-display-field";
    this.skipPlaceHolder = options.skipPlaceHolder || true;
    this.validations = options.validations || {};
    this.errors = options.errors || {};
    this.initIsDisabled = options.initIsDisabled || false;
    this.recordId = initialValues?.id || options.recordId || "";
    this.calculatedFields = options.calculatedFields || {} as ICalculatedFieldsOptions;
    this.calculatedTargetFields = options.calculatedTargetFields || {} as ICalculatedFieldsOptions;
    this.widths = options.widths || 2;
    this.blankWidth = options.blankWidth || 5 as WidthType;
    this.submitSuffix = options.submitSuffix || "";
    this.submitConfirmationMessage = options.submitConfirmationMessage || "";
    this.submitAlertMessage = options.submitAlertMessage || "";
    this.deleteSuffix = options.deleteSuffix || "";
    this.saveAndContinueSuffix = options.saveAndContinueSuffix || "";
    this.uploadDocSuffix = options.uploadDocSuffix || "";
    this.submitMethod = options.submitMethod ? options.submitMethod : this.values.id ? GlobalConstants.FetchMethods.PUT as MethodTypes : GlobalConstants.FetchMethods.POST as MethodTypes;
    this.payloadDataType = options.payloadDataType || "JSON";
    this.clearSuffixesOnSubmit = options.clearSuffixesOnSubmit;
    this.exitEditOnClose = options.exitEditOnClose;
    this.noBorder = options.noBorder || false;
    this.onFormChange = options.onFormChange;
    this.isDebug = !!options.isDebug;
    this.errorTitle = options.errorTitle;
    this.errorTitleClassName = options.errorTitleClassName;
    this.onSubmitSuccess = options.onSubmitSuccess;
    this.onSubmitSuccessMessage = options.onSubmitSuccessMessage;
    this.successMessageFormatterFunc = options.successMessageFormatterFunc;
    this.skipAutoCloseSuccessMessage = options.skipAutoCloseSuccessMessage;
    this.onSaveContinue = options.onSaveContinue;
    this.displayMessageLocally = !!options.displayMessageLocally;
    this.isCompact = options.isCompact;
    this.addressFields = options.addressFields || {};
    this.mailingIsSameAsPhysicalFieldName = options.mailingIsSameAsPhysicalFieldName || "";
    this.styles = options.styles || {};
    this.groupStyles = options.groupStyles || {};
    this.hiddenFields = options.hiddenFields || {};
    this.disabledFields = options.disabledFields || {};
    this.dropdownOptionsDataArrays = options.dropdownOptionsDataArrays || {};
    this.onDropdownOptionsLoaded = options.onDropdownOptionsLoaded;
    this.allDropdownOptionsAreReady = options?.allDropdownOptionsAreReady;
  }

  getInputField = (label: string, options: IFormGeneratorFieldOptions = {}) => {
    const defaultName = options.field === "dropdown" && options.fieldType !== "display" ? convertToCamelCase(label) + "Id" : convertToCamelCase(label);
    const formFieldName = options?.name || defaultName;
    if (formFieldName) {
      if (options.fieldType === "file") {
        const fileName = options.documentFileName && this.initialValues[options.documentFileName] ? this.initialValues[options.documentFileName] : this.initialValues[formFieldName] || options.value;
        if (fileName) {
          const fileBlob = options.fileFieldName && this.initialValues[options.fileFieldName] ? this.initialValues[options.fileFieldName] : this.initialValues[formFieldName];
          const downloadFileProps = { fileName, documentDownloadUrl: options.documentDownloadSuffix, fileBlob };
          this.initFileDownloads = this.initFileDownloads ? { ...this.initFileDownloads, [formFieldName]: downloadFileProps } : { [formFieldName]: downloadFileProps };
        }

        if (options.uploadDocSuffix) {
          this.uploadDocSuffix = options.uploadDocSuffix;
        }
      }
      else {
        const values = options.fieldType === "display" ? this.displayValues : this.values;
        const isTextInput = !options.field || (options.field === "input" && options.fieldType === "text");
        let value = options.defaultValue;

        if (options.value !== undefined) {
          value = isTextInput && typeof options.value === "boolean" ? convertBoolToText(options.value) : options.value;
        }
        else {
          if (this.initialValues[formFieldName] !== undefined && this.initialValues[formFieldName] !== null) {
            value = isTextInput && typeof this.initialValues[formFieldName] === "boolean" ? convertBoolToText(this.initialValues[formFieldName]) : this.initialValues[formFieldName];
          }
          else {
            if (options.isDefaultDateNow) {
              value = addTimestamp(removeTimestamp(new Date().toISOString()));
            }
          }
        }

        if (value !== undefined) {
          if (options.nestedInputsProp !== undefined) {
            if (values[options.nestedInputsProp] !== undefined) {
              values[options.nestedInputsProp][formFieldName] = value;
            }
            else {
              values[options.nestedInputsProp] = { [formFieldName]: value };
            }
          }
          else {
            values[formFieldName] = value;
          }
        }
      }
    }

    if (options.maskedValue) {
      this.maskedValues[formFieldName] = options.maskedValue;
    }

    if (options?.validations) {
        this.validations[formFieldName] = options?.validations;
    }

    if (options.required && options.field !== "label") {
      if (!options.validations || !options?.validations?.includes("required")) {
        if (typeof options.required === "object") {
          const requiredCondition = { required: options.required };
          this.validations[formFieldName] = this.validations[formFieldName] ? [...this.validations[formFieldName], requiredCondition] : [requiredCondition];
        }
        else {
          this.validations[formFieldName] = this.validations[formFieldName] ? [...this.validations[formFieldName], "required"] : ["required"];
        }
      }
    }

    if (options.fieldType === "dollar" || options.fieldType === "percent" || options.fieldType === "float") {
      this.numberFields.push(formFieldName);
    }

    if (options.calculatedFields) {
      const calculatedFieldsOptions = options.calculatedFields.map(fieldName => {
        return { name: fieldName, nestedInputsProp: options.nestedInputsProp, targetField: formFieldName };
      });

      options.calculatedFields?.map(f => {
        this.calculatedFields[f] = {
          valueField: formFieldName,
          calculatedFields: calculatedFieldsOptions as ITriggerField[],
          calculatedFunc: options.calculatedFunc,
          type: options.calculatedType,
          nestedInputsProp: options.nestedInputsProp
        };
      });
    }
    else {
      if (options.calculatedTargetField) {
        const calculatedField = { name: formFieldName, nestedInputsProp: options.nestedInputsProp, targetField: options.calculatedTargetField } as ITriggerField;
        const calculatedOptions: any = {
          valueField: options.calculatedTargetField,
          calculatedFields: [calculatedField],
          type: options.calculatedType
        };

        if (options.calculatedFunc) {
          calculatedOptions.calculatedFunc = options.calculatedFunc;
        }

        if (!this.calculatedTargetFields[options.calculatedTargetField]) {
          this.calculatedTargetFields[options.calculatedTargetField] = calculatedOptions;
        }
        else {
          if (this.calculatedTargetFields[options.calculatedTargetField].calculatedFields) {
            this.calculatedTargetFields[options.calculatedTargetField].calculatedFields.push(calculatedField);
          }
          else {
            this.calculatedTargetFields[options.calculatedTargetField] = { ...this.calculatedTargetFields[options.calculatedTargetField], ...calculatedOptions };
          }
        }

        if (!this.calculatedTriggerFields) {
          this.calculatedTriggerFields = [calculatedField];
        }
        else {
          this.calculatedTriggerFields.push(calculatedField);
        }
      }
      else {
        if (options.calculatedFunc) {
          if (this.calculatedTargetFields[formFieldName]) {
            this.calculatedTargetFields[formFieldName].calculatedFunc = options.calculatedFunc;
          }
          else {
            this.calculatedTargetFields[formFieldName] = { calculatedFunc: options.calculatedFunc };
          }
        }
      }
    }

    if (options.isHidden || options.isHiddenFunc) {
      this.hiddenFieldsRules[formFieldName] = { rule: options.isHidden, operation: options.isHiddenOperation, func: options.isHiddenFunc };
    }

    if (options.isDisabledOn || options.isDisabledOnFunc) {
      this.disabledFieldsRules[formFieldName] = { rule: options.isDisabledOn, operation: options.isDisabledOnOperation, func: options.isDisabledOnFunc };
    }

    if (options.field === "dropdown") {
      const dropdownOptions = options.dropdownOptions;
      if (typeof dropdownOptions === "string") {
        if (!this.dropdownOptionsDataArrays[dropdownOptions]) {
          if (!options.dependencyField && !options.optionalDropdownQueries && !options?.addressFieldType) {
            if(!("dropdownOptionsIsPromiseAll" in options)) {
              options.dropdownOptionsIsPromiseAll = true;
            }
            if (!this.allDropdownOptions.includes(dropdownOptions) && dropdownOptions !== "") {
              this.allDropdownOptions.push(dropdownOptions);
            }
          }
        }
      }
      else {
        this.dropdownOptionsDataArrays[formFieldName] = dropdownOptions;
      }
    }

    if (options.mailingAddressMapping) {
      this.addressFields[formFieldName] = options.mailingAddressMapping;
    }

    let fieldClassName: string;

    if (options.position && GlobalConstants.FieldPositionStyles[options.position]) {
      fieldClassName = GlobalConstants.FieldPositionStyles[options.position];
    }
    else if (options.inline) {
      fieldClassName = "lms-inline-form-field";
    }
    else if (options.inlineRight && options.field !== "checkbox") {
      fieldClassName = "lms-inline-right-form-field";
    }
    else {
      fieldClassName = this.fieldClassName;
    }

    if (options.noBackground) fieldClassName = `${fieldClassName} no-background`;
    if (options.fontWeightLight) fieldClassName = `${fieldClassName} font-weight400`;
    if (options.textAlignRight) fieldClassName = `${fieldClassName} text-align-right`;
    if (options.labelColor === "red") fieldClassName = `${fieldClassName} label-color-red`;
    if (options.valueColor === "red") fieldClassName = `${fieldClassName} color-red`;
    if (options.wrapLabel === true) fieldClassName = `${fieldClassName} wrap-label`;
    options.fieldClassName = fieldClassName;

    const minDateString = options.minDate !== undefined ? getFormattedMinMaxDate(options.minDate) : undefined;
    const maxDateString = options.maxDate !== undefined ? getFormattedMinMaxDate(options.maxDate) : undefined;

    return {
      field: "input",
      fieldType: "text",
      name: formFieldName,
      label: !(options.field === "checkbox" && options.inlineRight) ? label : "",
      placeHolder: this.skipPlaceHolder || !label ? "" : label,
      value: "",
      required: options.required || options?.validations?.includes("required"),
      disabled: options.disabled || !!options.calculatedFields,
      checkboxText: options.field === "checkbox" && options.inlineRight ? label || options.label || options.checkboxText : "",
      tableName: options.inlineEdit && (options?.name || defaultName) ? convertToCamelCase(options?.name || defaultName) : undefined,
      ...options,
      minDate: minDateString,
      maxDate: maxDateString,
    };
  };

  addFormInputField = (name: string, options: IFormGeneratorFieldOptions = {}) => {
    this.fields.push(this.getInputField(name, options));
  }

  getDropdownField = (
    label: string,
    dropdownOptions: DropdownOptionsTypes = [],
    options: IFormGeneratorFieldOptions = {}
  ) => {
    return this.getInputField(label, { ...options, field: "dropdown", dropdownOptions });
  };

  getDropdownDisplayField = (
    label: string,
    options: IFormGeneratorFieldOptions = {}
  ) => {
    const name = options.name || convertToCamelCase(label) || "";
    const value = options.value || this.initialValues[name] || this.values[name];
    const dropdownOptions = value ? [getDropdownSemanticOption(value)] : [];
    return this.getInputField(label, { field: "dropdown", fieldType: "display", disabled: true, dropdownOptions, ...options });
  };

  addDropdownField = (name: string, dropdownOptions: DropdownOptionsTypes = [] as DropdownOptionsTypes, options: IFormGeneratorFieldOptions = {}) => {
    this.fields.push(this.getDropdownField(name, dropdownOptions, options));
  }

  getFormGroupFields(fieldOptions: any[], options: IGroupFieldsOptions = {}) {
    if (options.radioGroupName) {
      if (options.radioGroupValue !== undefined && options?.radioGroupName) {
        this.values[options?.radioGroupName] = options.radioGroupValue;
      }
      else {
        this.values[options.radioGroupName] = this.initialValues[options.radioGroupName] || "";
      }

      if (options.isHidden || options.isHiddenOperation || options.isHiddenFunc) {
        this.hiddenFieldsRules[options.radioGroupName] = { rule: options.isHidden, operation: options.isHiddenOperation, func: options.isHiddenFunc };
      }
    }

    fieldOptions?.map(fo => {
      if (fo.isHidden || fo.isHiddenOperation || fo.isHiddenFunc) {
        this.hiddenFieldsRules[fo.name] = { rule: fo.isHidden, operation: fo.isHiddenOperation, func: fo.isHiddenFunc };
      }
    });

    return {
      groupFields: fieldOptions,
      widths: this.widths,
      ...options,
    };
  }

  addGroupFields(fieldOptions, options: IGroupFieldsOptions = {}) {
    const blankWith = options?.blankWidth ? options?.blankWidth : this.blankWidth as WidthType;
    let groupFields = fieldOptions;
    let groupOptions = { ...options };

    if (options.nestedInputsProp) {
      groupFields = fieldOptions?.map(fo => {
        if (options.nestedInputsProp && !fo.nestedInputsProp) {
          return { ...fo, nestedInputsProp: options.nestedInputsProp };
        }

        return fo;
      });
    }

    if (options?.isCentered) {
      const updatedFieldOptions = groupFields?.map(fo => {
        let fieldOptionCopy = { ...fo };
        if (options?.isCentered && !fo.width) {
          fieldOptionCopy = { ...fo, width: (16 - (2 * +blankWith)) / fieldOptions.length };
        }

        return fieldOptionCopy;
      });

      groupFields = [
        this.getBlankField({ width: blankWith }),
        ...updatedFieldOptions,
        this.getBlankField({ width: blankWith }),
      ];

      groupOptions = { ...options, widths: 1 };
    }

    this.fields.push(this.getFormGroupFields(groupFields, groupOptions));
  }

  addCenteredGroup(fieldOptions, options: IGroupFieldsOptions = {}) {
    this.addGroupFields(fieldOptions, { ...options, isCentered: true });
  }

  getCurrencyField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, fieldType: GlobalConstants.InputTypes.DOLLAR as FieldTypes });
  }

  addCurrencyField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getCurrencyField(label, { ...options }));
  }

  getNumberField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, fieldType: GlobalConstants.InputTypes.INT as FieldTypes });
  }

  addNumberField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getNumberField(label, { ...options }));
  }

  getPercentField(label: string, maxPercentage?: string | number, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, fieldType: GlobalConstants.InputTypes.PERCENT as FieldTypes, maxPercentage });
  }

  addPercentField(label: string, maxPercentage?: string | number, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getPercentField(label, maxPercentage, { ...options }));
  }

  getCheckboxField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, field: GlobalConstants.FormInputTypes.CHECKBOX as LmsInputFieldTypes });
  }

  addCheckboxField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getCheckboxField(label, { ...options }));
  }

  getCalendarField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, field: GlobalConstants.FormInputTypes.CALENDAR as LmsInputFieldTypes });
  }

  addCalendarField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getCalendarField(label, { ...options }));
  }

  getTextareaField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, field: GlobalConstants.FormInputTypes.TEXTAREA as LmsInputFieldTypes });
  }

  addTextareaField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getTextareaField(label, { ...options }));
  }

  getFileField(label, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...options, fieldType: GlobalConstants.FormInputTypes.FILE as FieldTypes });
  }

  addFileField(label: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getFileField(label, { ...options }));
  }

  getLinkField(label, options: IFormLinkFieldOptions) {
    const actionType = options.linkType || "Download";
    const actionIcon = actionType === "Download" || actionType === "DownloadFile" ? GlobalConstants.Icons.DOWNLOAD : GlobalConstants.Icons.EXTERNAL_LINK;
    const actionButtonText = actionType === "Download" || actionType === "DownloadFile" ? "Download" : label || "";
    const name = options.name || convertToCamelCase(label) || "";
    const value = options.linkName || this.initialValues[name] || options.link || "";

    const actionFunc = async () => {
      if (actionType === "Download") {
        downloadUrl(options.link, label || "");
      }
      else if (actionType === "DownloadFile") {
        await downloadFile(options.link, { fileName: value, method: options.method || "GET" });
      }
      else {
        navigateToUrl(options.link);
      }
    };

    return this.getActionField(label, { actionFunc, actionLabel: actionButtonText, actionIcon: actionIcon }, {
      fieldClassName: "lms-disabled-action-display-field",
      value: options.linkName || this.initialValues[name] || options.link,
      disabled: true,
      isActionEnabled: true,
      ...options,
    });
  }

  addLinkField(label: string, options: IFormLinkFieldOptions) {
    this.fields.push(this.getLinkField(label, { ...options }));
  }

  getListField(name: string, listOptions: IFormListFieldOptions, options: IFormGeneratorFieldOptions = {}) {
    const linkType = listOptions.linkType || "Navigate";
    const value = this.initialValues[name] || listOptions.listOptions;

    const handleClick = async (option) => {
      const link = typeof option === "string" ? option : option.link;
      const linkName = typeof option === "string" ? option : option.linkName || link;
      if (linkType === "Download") {
        downloadUrl(link, linkName);
      }
      else if (linkType === "DownloadFile") {
        await downloadFile(link, { fileName: linkName, method: listOptions.downloadMethod || "GET" });
      }
      else {
        navigateToUrl(link);
      }
    };

    return {
      field: "list",
      value,
      name,
      handleClick,
      ...listOptions,
      ...options
    };
  }

  addListField(label: string, options: IFormLinkFieldOptions) {
    this.fields.push(this.getListField(label, { ...options }));
  }

  getActionField(label, actionOptions: IFormGeneratorActionFieldOptions, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { ...actionOptions, ...options });
  }

  addActionField(label, actionOptions: IFormGeneratorActionFieldOptions, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getActionField(label, actionOptions, options));
  }

  getActionDropdownField(label, dropdownOptions: DropdownOptionsTypes = [], actionOptions: IFormGeneratorActionFieldOptions, options: IFormGeneratorFieldOptions = {}) {
    return this.getDropdownField(label, dropdownOptions, { ...actionOptions, ...options });
  }

  addActionDropdownField(label, dropdownOptions: DropdownOptionsTypes = [], actionOptions: IFormGeneratorActionFieldOptions, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getActionDropdownField(label, dropdownOptions, actionOptions, options));
  }

  getLabelField(name: string, options: IFormGeneratorLabelFieldOptions = {}) {
    return this.getInputField(name, { ...options, field: "label" });
  }

  addLabelField(name: string, options: IFormGeneratorLabelFieldOptions = {}) {
    this.fields.push(this.getLabelField(name, { ...options }));
  }

  getWarningTextField(text: string, options: IFormGeneratorFieldOptions = {}) {
    return this.getInputField("", { ...options, field: "warningText", warningFieldText: text, valueColor: "red" });
  }

  addWarningTextField(text: string, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getWarningTextField(text, { ...options, field: "warningText", warningFieldText: text, valueColor: "red" }));
  }

  getPlainTextField(text: string, fieldOptions: IFormGeneratorLabelFieldOptions = {}) {
    if (!fieldOptions.fieldLabelClassName) {
      fieldOptions.fieldLabelClassName = "lms-form-generator-field-plain-text";
    }

    return this.getInputField(text, { ...fieldOptions, field: "label" });
  }

  addPlainTextField(text: string, fieldOptions: IFormGeneratorBlankFieldOptions = {}) {
    this.fields.push(this.getPlainTextField(text, fieldOptions));
  }

  getDisplayField(text: string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(text, {...fieldOptions , fieldType: "display", disabled:true });
  }

  addDisplayField(text: string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getDisplayField(text, fieldOptions);
  }

  getBlankField(fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getInputField("", { ...fieldOptions, field: "label" });
  }

  addBlankField(fieldOptions: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getBlankField(fieldOptions));
  }

  getMaskedInputField(label: string, initValue: any, fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { placeHolder: getMaskedString(initValue), value: "", maskedValue: initValue, ...fieldOptions });
  }

  getSocialSecurityField(label: string, initValue: any, fieldOptions:IFormGeneratorFieldOptions = {}) {
    return this.getInputField(label, { placeHolder: getMaskedString(initValue, 4, "*", true), value: "", maskedValue:initValue, validations: ["socialSecurityNumber"], ...fieldOptions });
  }

  getButtonField(text, onButtonClick?: ((arg0?: any) => any) | string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getInputField(text, { ...fieldOptions, onButtonClick, field: "button" });
  }

  addButtonField(text, onButtonClick?: ((arg0?: any) => any) | string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getButtonField(text, onButtonClick, fieldOptions));
  }

  getButtonsGroupField(buttonsGroup: IFormGeneratorFieldOptions[], fieldOptions: IFormGeneratorFieldOptions = {}) {
    return this.getInputField("", { ...fieldOptions, buttonsGroup, field: "buttonsGroup" });
  }

  addButtonsGroupField(buttonsGroup: IFormGeneratorFieldOptions[], fieldOptions: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getButtonsGroupField(buttonsGroup, fieldOptions));
  }

  getDownloadButtonField(text, downloadLink?: string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    const onButtonClick = () => {
      return downloadFile(downloadLink, { fileName: fieldOptions?.name, method: fieldOptions?.buttonDownloadMethod });
    };

    return this.getInputField(text, {
      ...fieldOptions, onButtonClick: onButtonClick, field: "button"
    });
  }

  addDownloadButtonField(text, downloadLink?: string, fieldOptions: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getDownloadButtonField(text, downloadLink, fieldOptions));
  }

  addDividerField({ dividerText = "", dividerIsHidden = false } = {}) {
    this.fields.push({ isDivider: true, dividerText, dividerIsHidden });
  }

  getComponent(component: any, options: IFormGeneratorFieldOptions = {} ) {
    return this.getInputField("", { ...options, component });
  }

  addComponent(component: any, options: IFormGeneratorFieldOptions = {}) {
    this.fields.push(this.getComponent(component, options));
  }

  getGroupRadioField(name: string, options: IFormGeneratorFieldOptions = {}) {
    return {
      field: "radio",
      name: convertToCamelCase(name),
      label: name,
      value: options.name || name,
      ...options,
    };
  }

  addGroupRadioField(name: string, options: any = {}) {
    this.fields.push(this.getGroupRadioField(name, options));
  }

  addAddressSectionToForm = (isPhysical = false, groupOptions?: IGroupFieldsOptions, isCountyRequired = false) => {
    this.addAddressOnlySectionToForm(isPhysical, groupOptions, isCountyRequired);
    this.addMailingIsSameAsPhysicalField({}, groupOptions);
    this.addMailingAddressOnlySectionToForm(groupOptions, isCountyRequired);
  };

  addAddressOnlySectionToForm = (isPhysical = false, groupOptions = {}, isCountyRequired) => {
    if (isPhysical) {
      addPhysicalAddressFields(this, groupOptions, isCountyRequired);
    }
    else {
      addAddressFields(this, groupOptions, isCountyRequired);
    }
  }

  addMailingAddressOnlySectionToForm = (groupOptions = {} as IGroupFieldsOptions, isCountyRequired) => {
    addMailingAddressFields(this, groupOptions, isCountyRequired);
  }

  addMailingIsSameAsPhysicalField = (options: IFormGeneratorFieldOptions = {}, groupOptions = {} as IGroupFieldsOptions) => {
    addMailingIsSameAsPhysicalField(this, options, groupOptions);
  }

  getZipCodeField = (label = "Zip Code", options?: IFormGeneratorFieldOptions) => {
    return this.getInputField(label, { name: "zip", validations: ["required", "zipcode"], mailingAddressMapping: "mailingZip", ...options });
  };

  getStateField = (label = "State", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "stateName", addressFieldType: "state", dependencyField: "zip", required: true, mailingAddressMapping: "mailingStateName", ...options });
  };

  getCityField = (label = "City", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "cityName", addressFieldType: "city", dependencyField: "zip", required: true, mailingAddressMapping: "mailingCityName", ...options });
  };

  getCountyField = (label = "County", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "countyName", addressFieldType: "county", dependencyField: "zip", mailingAddressMapping: "mailingCountyName", ...options });
  };

  getStreetField = (label = "Street Address", options?: IFormGeneratorFieldOptions) => {
    return this.getInputField(label, { required: true, name: "street", mailingAddressMapping: "mailingStreet", ...options });
  }

  getMailingZipCodeField = (label = "Mailing Zip Code", options?: IFormGeneratorFieldOptions) => {
    return this.getInputField(label, { name: "mailingZip", validations: ["required", "zipcode"], ...options });
  };

  getMailingStateField = (label = "Mailing State", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "mailingStateName", addressFieldType: "state", dependencyField: "mailingZip", required: true, ...options });
  };

  getMailingCityField = (label = "Mailing City", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "mailingCityName", addressFieldType: "city", dependencyField: "mailingZip", required: true, ...options });
  };

  getMailingCountyField = (label = "Mailing County", options?: IFormGeneratorFieldOptions) => {
    return this.getDropdownField(label, "", { name: "mailingCountyName", addressFieldType: "county", dependencyField: "mailingZip", ...options });
  };

  getMailingStreetField = (label = "Mailing Street Address", options?: IFormGeneratorFieldOptions) => {
    return this.getInputField(label, { name: "mailingStreet", required: true, ...options });
  }

  setSubmitSuffix = (suffix) => {
    this.submitSuffix = suffix;
  }

  setFields = (fields) => {
    this.fields = fields;
  }
}

export const getInitialValues = (formsArr) => {
  return formsArr.reduce((initialValues, current) => {
    return { ...initialValues, ...current.values };
  }, {});
};

export const LmsFormField = ({
     options = {} as any,
     inputs = {},
     displayValues = {},
     errors = {},
     handleChange = undefined as ((...args: any) => any) | undefined,
     onBlur = undefined as ((...args: any) => any) | undefined,
     labelClassName = "lms-form-generator-field-label",
     fieldClassName = "",
     isDisabled = false,
     isRequired = false,
     value,
     skipLabel = false,
     hideErrorMessage = false,
     isTableInline = false,
     useFormInstance = {} as IUseFormInstance,
     isActionEnabled = false,
     fileDownloads = {},
     isCompact = false
 }) => {
  let label = skipLabel || options.checkboxText ? null : options.onDisabledLabel && useFormInstance?.isDisabled ? options.onDisabledLabel : options?.label;
  if (options?.labelFunc) {
    label = options.labelFunc(useFormInstance, options);
  }

  return <LMSFormInput
    key={options.name}
    type={options?.field}
    fieldType={options?.fieldType}
    unitType={options?.unitType}
    name={options?.name}
    value={value !== undefined ? value : inputs[options.name] !== undefined ? inputs[options.name] : displayValues[options.name] !== undefined ? displayValues[options.name] : ""}
    defaultValue={options?.defaultValue}
    radioValue={options.radioValue}
    label={label}
    errorLabel={options?.errorLabel}
    labelClass={labelClassName}
    labelWarningText={options.labelWarningText}
    labelColor={options.labelColor}
    fieldClass={fieldClassName}
    placeholder={options?.placeHolder}
    inline={options?.inline}
    handleFormChange={handleChange}
    onBlur={onBlur}
    disabled={useFormInstance?.isDisabled || options.disabled || isDisabled}
    width={options.width}
    required={isRequired}
    error={errors[options?.name]}
    actionPath={options?.actionPath}
    actionFunc={options?.actionFunc}
    actionLabel={options?.actionLabel}
    actionIcon={options?.actionIcon}
    isActionEnabled={isActionEnabled}
    modalContent={options?.modalContent}
    modalSize={options?.modalSize}
    hideErrorMessage={hideErrorMessage}
    isTableInline={isTableInline}
    useFormInstance={useFormInstance}
    checkboxText={options?.checkboxText}
    fileDownloads={fileDownloads}
    isCompact={isCompact}
    nestedInputsProp={options.nestedInputsProp}
    maxPercentage={options.maxPercentage}
    maxValue={options.maxValue}
    decimalsLimit={options.decimalsLimit}
    allowNegativeValue={options.allowNegativeValue}
    minDate={options.minDate}
    maxDate={options.maxDate}
  />;
};

export const LmsFormDropdownField = ({
   options = {} as any,
   inputs = {},
   displayValues = {},
   dropdownOptionsData = null,
   errors = {},
   hasError = (depField?: string) => depField as any,
   handleChange = undefined as ((...args: any) => any) | undefined,
   onBlur = undefined as ((...args: any) => any) | undefined,
   labelClassName = "lms-form-generator-field-label",
   fieldClassName = "",
   isDisabled = false,
   isRequired = false,
   isActionHidden = false,
   isActionEnabled = false,
   value,
   name,
   isLoading = false,
   skipLabel = false,
   isPromiseAll = false,
   hideErrorMessage = false,
   upward = false,
   isTableInline = false,
   useFormInstance = {} as IUseFormInstance,
   isCompact = false,
 }: any) => {
  const fieldName = name || options.name;
  const dependencyFieldCamel = convertToCamelCase(options.dependencyField || "");
  const dependencyHasError = options.dependencyField && hasError(dependencyFieldCamel);
  const dependencyFieldValue = !dependencyHasError ? inputs[dependencyFieldCamel] : "";
  let promiseToResolve = options?.dropdownOptions;
  if (typeof options?.dropdownOptions === "string") {
    const getListApiSuffix = () => {
      if (options.dependencyFieldQuery) {
        return `${options.dropdownOptions}${options.dropdownOptions.includes("?") ? "&" : "?"}${options.dependencyFieldQuery}=${dependencyFieldValue}`;
      }
      else if (options.dropdownOptions.includes("{id}")) {
        return options.dropdownOptions.replace("{id}", dependencyFieldValue);
      }
      else if (options.dropdownOptions.includes(":id")) {
        return options.dropdownOptions.replace(":id", dependencyFieldValue);
      }
      else {
        return `${options.dropdownOptions}/${dependencyFieldValue}`;
      }
    };

    promiseToResolve = dependencyFieldValue ? getListApiSuffix() : dependencyFieldCamel ? "" : options.dropdownOptions;

    if (options.optionalDropdownQueries) {
      options.optionalDropdownQueries.forEach((query) => {
        const queryFieldCamel = convertToCamelCase(query.fieldName);
        const queryFieldValue = inputs[queryFieldCamel];
        promiseToResolve = appendParam(promiseToResolve, query.query, queryFieldValue);
      });
    }
  }

  const isFormattedArray = Array.isArray(options?.dropdownOptions) || Array.isArray(dropdownOptionsData?.[fieldName]);
  const initialData = isFormattedArray && !dropdownOptionsData?.[fieldName] ? options?.dropdownOptions : dropdownOptionsData?.[fieldName] ? dropdownOptionsData?.[fieldName] : dependencyHasError ? [] : null;
  const { promiseData: dropdownOptions, promiseError: dropdownError, promiseLoading: dropdownLoading, setPromiseLoading, getDropdownOptionsNow } = usePromise(promiseToResolve, {
    initialData,
    dependencyHasError,
    cleanError: true,
    subPath: options.dropdownOptionsSubPath,
    dropdownOptionsData,
    isPromiseAll,
    dependencyFieldValue,
    fieldName: fieldName,
    fieldValue: value || inputs[fieldName] || displayValues[fieldName] || "",
    addressFieldType: options.addressFieldType as AddressFieldTypes,
    dropdownSkipCache: options.dropdownSkipCache,
  });

  const formattedOptions = useMemo(() => {
    return formatDropdownOptions(dropdownOptions, options.dropdownListKey, isFormattedArray, initialData);
  }, [
    options.dropdownOptions,
    dropdownOptions,
    value,
    inputs[fieldName],
    displayValues[fieldName],
    dropdownOptionsData?.[fieldName]?.length,
  ]);

  const getValueExistsInMulti = (selectedValue, value) => selectedValue && Array.isArray(selectedValue) && selectedValue?.includes(value);
  const defaultOptions = useMemo(() => {
    if (formattedOptions && Array.isArray(formattedOptions) && formattedOptions.length > GlobalConstants.DefaultValues.DROPDOWN_LIMIT) {
      const firstOptions = formattedOptions?.slice(0, GlobalConstants.DefaultValues.DROPDOWN_LIMIT);
      const selectedValue = inputs[fieldName];

      if (selectedValue && !firstOptions.some(fo => fo.value === selectedValue || getValueExistsInMulti(selectedValue, fo.value))) {
        const selectedOption = formattedOptions.find(fo => fo.value === selectedValue || getValueExistsInMulti(selectedValue, fo.value));
        if (selectedOption) {
          firstOptions.push(selectedOption);
        }
      }

      return firstOptions;
    }

    return formattedOptions || [];
  }, [formattedOptions]);
  const [displayedOptions, setDisplayedOptions] = useState([] as any[]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    if (formattedOptions && defaultOptions) {
      setDisplayedOptions(defaultOptions);
    }
  }, [formattedOptions, defaultOptions]);

  const handleSearchChange = (e, data) => {
    setSearchQuery(data.searchQuery || "");
    if (!data.searchQuery || data.searchQuery.length === 0) {
      setDisplayedOptions(defaultOptions);
    }
    else {
      const searchedOptions = formattedOptions?.filter(fo => {
        if (typeof fo?.text === "string") {
          return fo.text?.toLowerCase().includes(data?.searchQuery?.toLowerCase());
        }

        return false;
      }) || [];
      setDisplayedOptions(searchedOptions);
    }
  };

  const handleDropdownChange = (e, data, refreshOptions) => {
    if (refreshOptions) {
      if (!isPromiseAll) {
        getDropdownOptionsNow();
      }
      else {
        setPromiseLoading(true);
        useFormInstance?.refreshDropdownOptions?.(options?.dropdownOptions, false, () => setPromiseLoading(false));
      }
    }

    setSearchQuery("");
    const isDefault = defaultOptions.find(fo => fo.value === data.value || getValueExistsInMulti(data.value, fo.value));
    if (!isDefault) {
      const selectedOption = formattedOptions?.find(fo => fo.value === data.value || getValueExistsInMulti(data.value, fo.value));
      if (selectedOption) {
        setDisplayedOptions([selectedOption, ...defaultOptions]);
      }
    }
    else {
      setDisplayedOptions([...defaultOptions]);
    }

    handleChange(e, data);
  };

  const dropdownValue = useMemo(() => {
    const tempValue = value !== undefined ? value : inputs[fieldName] !== undefined ? inputs[fieldName] : displayValues[fieldName] !== undefined ? displayValues[fieldName] : "";

    if (tempValue && (isGuid(tempValue) || Array.isArray(tempValue))) {
      return tempValue;
    }
    else {
      if (formattedOptions && tempValue) {
        const foundOption = formattedOptions.find(fo => fo.text === tempValue);
        if (foundOption) {
          return foundOption.value;
        }
      }
    }

    return tempValue;
  }, [value, inputs[fieldName] , displayValues[fieldName], formattedOptions]);

  useEffect(() => {
    if (dependencyHasError && dropdownValue) {
      handleChange(null, { value: null, name: fieldName });
    }
  }, [dependencyHasError]);

  let label = skipLabel || options.checkboxText ? null : options.onDisabledLabel && useFormInstance?.isDisabled ? options.onDisabledLabel : options?.label;
  if (options?.labelFunc) {
    label = options.labelFunc(useFormInstance, options);
  }

  return <LMSFormInput
    key={fieldName}
    type={options?.field}
    fieldType={options?.fieldType}
    unitType={options?.unitType}
    name={fieldName}
    value={dropdownValue}
    radioValue={options.radioValue}
    dependencyFieldValue={dependencyFieldValue}
    label={label}
    errorLabel={options?.errorLabel}
    labelClass={labelClassName}
    labelColor={options.labelColor}
    labelWarningText={options.labelWarningText}
    fieldClass={fieldClassName}
    placeholder={options?.placeHolder}
    inline={options?.inline}
    handleFormChange={handleDropdownChange}
    onBlur={onBlur}
    handleSearchChange={handleSearchChange}
    dropdownOptions={dependencyHasError ? [] : displayedOptions}
    setDropdownOptions={setDisplayedOptions}
    getDropdownOptionsNow={getDropdownOptionsNow}
    dropdownError={!!dropdownError}
    dropdownLoading={isLoading || dropdownLoading}
    dropdownMultiple={options.dropdownMultiple}
    searchQuery={searchQuery}
    disabled={(options.dependencyField && !dependencyFieldValue) || useFormInstance?.isDisabled || options.disabled || isDisabled}
    width={options.width}
    required={isRequired}
    error={errors[fieldName]}
    hideErrorMessage={hideErrorMessage}
    upward={upward}
    isTableInline={isTableInline}
    actionPath={options?.actionPath}
    actionFunc={options?.actionFunc}
    actionLabel={options?.actionLabel}
    actionIcon={options?.actionIcon}
    isActionHidden={isActionHidden}
    isActionEnabled={isActionEnabled}
    removeActionFunc={options?.removeActionFunc}
    removeActionLabel={options?.removeActionLabel}
    removeActionIcon={options?.removeActionIcon}
    displayRemoveButton={options?.displayRemoveButton}
    actionHasDependency={options?.actionHasDependency}
    useFormInstance={useFormInstance}
    modalContent={options?.modalContent}
    modalSize={options?.modalSize}
    isCompact={isCompact}
    nestedInputsProp={options.nestedInputsProp}
    skipClearable={options.skipClearable}
    clearable={options.clearable}
  />;
};

interface ILmsButtonFieldProps {
  buttonText?: string;
  buttonRenderType?: "button" | "link"
  fieldOptions: IFormGeneratorFieldOptions
  handleButtonClick: () => any
  isDisabled?: boolean
  useFormInstance: any
  modalContent?: FC<any>
  modalSize?: ModalSizesType
  isBasic?: boolean
  isAction?: boolean
  icon?: string
  isButtonGroup?: boolean
}

const LmsButtonField = (
  {
    fieldOptions,
    handleButtonClick,
    isDisabled,
    modalContent,
    modalSize = "large",
    buttonRenderType = "button" as LmsFormFieldButtonRenderType,
    useFormInstance,
    buttonText,
    isBasic = false,
    icon,
    isButtonGroup = false
  }: ILmsButtonFieldProps) => {
  const [isAddFormModalOpen, setIsAddFormModalOpen] = useState(false);
  const handleClick = () => {
    if (modalContent) {
      setIsAddFormModalOpen(true);
    }
    if (fieldOptions.onButtonClick) {
      handleButtonClick();
    }
  };

  const text = buttonText || fieldOptions?.label;
  let ButtonElement: any;

  if (buttonRenderType === "button") {
    ButtonElement = (<Button
      key="button-group-child-field"
      fluid={fieldOptions.fullWidth}
      onClick={handleClick}
      content={text}
      icon={icon || fieldOptions.buttonIcon}
      isBasic={isBasic}
      compact={fieldOptions.isCompact}
      className={`lms-form-button-group-field ${!text ? " button-icon-only" : ""}`}
    />);
  }
  else if (buttonRenderType === "link") {
    ButtonElement = (<div key="button-group-child-field" className={"lms-flex-centered-row-container height-100"}>
      <a
      onClick={handleClick}
    >
      {text}
    </a>
    </div>);
  }

  const fieldClassName = useMemo(() => {
    const res = "lms-form-generator-button-field-container";
    if (fieldOptions.position) {
      return `${res} ${fieldOptions.position}`;
    }

    if (fieldOptions.fullWidth) {
      return `${res} full-with`;
    }

    if (fieldOptions.alignRight) {
      return `${res} right`;
    }
    else if (fieldOptions.alignLeft) {
      return `${res} left`;
    }

    return res;
  }, []);

  return <>
    {isButtonGroup && ButtonElement}
    {!isButtonGroup && <Form.Field
      className={fieldClassName}
      width={fieldOptions.width}
      disabled={isDisabled}
      children={[ButtonElement]}
    />}
    {modalContent && isAddFormModalOpen && <BCModal
      isModalOpen={isAddFormModalOpen}
      size={modalSize}
      closeIcon
      onClose={() => setIsAddFormModalOpen(false)}
      content={modalContent ? modalContent(setIsAddFormModalOpen, { ...fieldOptions, ...useFormInstance }) : null}
    />}
  </>;
};

interface ILmsActionButtonProps {
  content?: string
  handleButtonClick: () => any
  isDisabled?: boolean
  useFormInstance: any
  modalContent?: (setIsAddFormModalOpen?: any, useFormInstance?: any) => FC<any>
  modalSize?: ModalSizesType
  className?: string
  negative?: boolean
  loading?: boolean
  icon: string
  index?: number
  size?: ButtonSizesType
  basic?: boolean
}

const LmsButtonAction = (
  {
    content = "",
    isDisabled = false,
    handleButtonClick,
    className = "",
    negative = false,
    loading = false,
    icon,
    modalContent,
    modalSize = "large",
    useFormInstance,
    index,
    basic = true,
    size = "small" as ButtonSizesType
  }: ILmsActionButtonProps) => {
  const [isAddFormModalOpen, setIsAddFormModalOpen] = useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);
  const handleClick = () => {
    if (modalContent) {
      setIsAddFormModalOpen(true);
    }
    if (handleButtonClick) {
      handleButtonClick();
    }
  };

  return <>
    <Button
      key={`button-group-action-child-field${index}${content || ""}`}
      onClick={handleClick}
      content={content}
      icon={icon}
      className={className}
      disabled={isDisabled}
      loading={loading}
      negative={negative}
      basic={basic}
      size={size}
    />
    {modalContent && isAddFormModalOpen && <BCModal
      isModalOpen={isAddFormModalOpen}
      size={modalSize}
      closeIcon
      onClose={() => setIsAddFormModalOpen(false)}
      isLoading={isModalLoading}
      content={modalContent ? modalContent(setIsAddFormModalOpen, { ...useFormInstance, setIsModalLoading }) : null}
    />}
  </>;
};

export interface IUseFormInstance {
  isDisabled: boolean;
  inputs: Record<string, unknown>;
  isFormInitLoaded?: boolean,
  setIsFormInitLoaded: any,
  formFields: any[],
  setFormFields: (fields?: any[]) => void
  initialValues: string;
  setInputs: any;
  metaData: Record<any, any>,
  setMetaData: any,
  lastUpdated: string;
  lastUpdatedNestedProp?: string;
  lastValue: any;
  setLastValue: any;
  displayValues: Record<string, unknown>;
  errors: Record<string, unknown>;
  hasError: (any) => any,
  setErrors: (any) => void;
  formErrorMessage?: IFormErrorMessage,
  setFormErrorMessage?: any,
  validations: Record<string, any>;
  validateForm: () => any;
  handleChange: (e: any, data: Record<string, unknown>, type?: string, prop?: any, onFieldChanged?: any, charLimit?: number) => void;
  resetForm: () => void;
  clearForm: () => void;
  handleIsHidden: (fieldOptions: any) => boolean;
  handleIsDisabled: (fieldOptions: any) => boolean;
  setIsDisabled: (boolean) => void;
  handleSubmit: (string, IHandleSubmitOptions) => any;
  handleDelete: (string, IHandleSubmitOptions) => any;
  handleDownloadFile: (downloadSuffix: string, downloadOptions?: IDownloadOptions, buttonText?: string) => any;
  submitting: boolean;
  isFormLoading: boolean;
  setSubmitting: any;
  initSubmittingStates: (buttonText: string) => void,
  resetSubmittingStates: () => void,
  submitError: any;
  displayMessageLocally?: boolean;
  setSubmitError: (error: Record<string, any>) => void;
  activeButtonText: string;
  setActiveButtonText: any;
  success: boolean;
  handleClose: (onClosePath?: string) => any;
  history: any,
  confirmOptions?: Record<string, any>
  setConfirmOptions?: any,
  handleConfirmFunc: (func?: any, confirmationMessage?: string, isAlert?: boolean, confirmButtonText?: string) => any
  fileDownloads?: Record<string, any>
  exitEditOnClose?: boolean
  addressFields?: Record<string, string>
  getNestedValue: (fieldOptions?: Record<string, any>) => any,
  allDropdownOptionsData,
  allDropdownOptionsIsLoading,
  reRenderFormField?: (fieldName?: string) => void
  modalIframeSrcPath?: string
  setModalIframeSrcPath?: any
  modalIframeSize?: string
  setModalIframeSize?: any
  modalIframeHeight?: number
  setModalIframeHeight?: any
  iframeModalRef: any
}

export interface IFormGeneratorCustomAction {
  action?: string
  text?: string
  icon?: string
  path?: string
  pathFunc?: (options: any) => string
  handleClick?: any
  method?: MethodTypes
  isDisabled?: (isDisabled?: boolean) => boolean
  modalContent?: ModalContentType
  modalSize?: ModalSizesType
  isIframeModal?: boolean
}

export type FormActionType = string | IFormGeneratorCustomAction | any
export type FormActionsType = FormActionType[]
export interface IFormSubmitValidationResponse {
  success?: boolean
  errorMessage?: string | string[]
  errorHeader?: string
}

interface ILmsFormGeneratorProps {
  myForm: BCFormController;
  inputs?: Record<string, unknown>;
  useFormInstance?: IUseFormInstance;
  handleSubmit?: (inputs: Record<string, unknown>, options: Record<string, unknown> | undefined) => void;
  onSubmitSuccess?: OnSubmitSuccessFuncType;
  onSubmitSuccessMessage?: string
  skipAutoCloseSuccessMessage?: boolean
  submitConfirmationMessage?: string | ((options?: any) => string)
  submitAlertMessage?: string | ((options?: any) => string)
  onSaveContinue?: OnSaveContinueFuncType;
  displayMessageLocally?: boolean;
  onEditClick?: (arg0?: any) => any
  onCloseClick?: (arg0?: any) => any
  onClosePath?: string
  submitSuffix?: string;
  deleteSuffix?: string;
  handleClose?: () => void;
  exitEditOnClose?: boolean;
  actions?: FormActionsType;
  topActions?: FormActionsType;
  hideTopActionsOnEdit?: boolean;
  onlyActions?: boolean;
  isLoading?: boolean;
  error?: any;
  skipActions?: boolean;
  hideBottomActionsOnEdit?: boolean
  onChange?: (options?: any) => any
  onFormChanged?: (options?: any, lastUpdated?: string, lastUpdatedNestedProp?: string) => any
  onInitLoad?: (options?: any) => any
  onBlur?: (fieldName?: string, fieldValue?: string, options?: any) => any
  isDisabled?: boolean
  initialValuesChanged?: (options?: any, lastUpdated?: string) => any
  isDebug?: boolean
  skipErrorAutoClose?: boolean
  handleSubmitValidation?: (inputs?: any, options?: any) => Promise<IFormSubmitValidationResponse>;
  componentProps?: Record<string, Record<string, any>>;
  recordId?: string;
  iframeModalSize?: string
  iframeModalHeight?: number
  renderAs?: "form" | "div"
}

const LmsFormGenerator = (props: ILmsFormGeneratorProps) => {
  const { values, recordId, submitSuffix, submitMethod, payloadDataType, deleteSuffix, isDebug, label, centeredTitle, errorTitle, isCompact, onFormChange } = props.myForm;
  const useFormOptions = {
    myForm: props.myForm,
    isDebug: isDebug || props.isDebug,
    initIsDisabled: !!props.error,
    isDisabled: props.isDisabled,
    exitEditOnClose: props.exitEditOnClose,
    onSubmitSuccess: props.onSubmitSuccess,
    onSubmitSuccessMessage: props.onSubmitSuccessMessage,
    skipAutoCloseSuccessMessage: props.skipAutoCloseSuccessMessage,
    onSaveContinue: props.onSaveContinue,
    displayMessageLocally: props.displayMessageLocally,
    isLoading: props.isLoading,
    recordId: props.recordId,
  };

  const useFormInstance = props.useFormInstance as IUseFormInstance || useForm(props.inputs || values, useFormOptions);
  const {
    inputs = {} as any,
    initialValues,
    isFormInitLoaded,
    setIsFormInitLoaded,
    formFields,
    errors = {},
    displayValues = {},
    getNestedValue,
    setErrors,
    validateForm,
    validations,
    isDisabled,
    handleChange,
    handleClose,
    handleIsHidden,
    handleIsDisabled,
    setIsDisabled,
    resetForm,
    handleSubmit,
    handleDelete,
    handleDownloadFile,
    submitting,
    initSubmittingStates,
    resetSubmittingStates,
    isFormLoading,
    submitError,
    formErrorMessage,
    setFormErrorMessage,
    displayMessageLocally,
    activeButtonText,
    success,
    history,
    confirmOptions,
    setConfirmOptions,
    handleConfirmFunc,
    fileDownloads,
    exitEditOnClose,
    lastUpdated,
    lastUpdatedNestedProp,
    lastValue,
    setLastValue,
    allDropdownOptionsData,
    allDropdownOptionsIsLoading,
    modalIframeSrcPath,
    setModalIframeSrcPath,
    modalIframeSize,
    setModalIframeSize,
    modalIframeHeight,
    setModalIframeHeight,
    iframeModalRef
  } = useFormInstance;
  const formActions: FormActionsType = props.actions ? props.actions : recordId || values?.id ? ["save", "save-close", "delete", "close"] : ["save-new", "save-continue", "save-close", "edit", "close"];
  let lmsCustomFormStyles = {} as IFormStyles;
  if (props.myForm?.styles) {
    lmsCustomFormStyles = props.myForm?.styles;
  }

  useEffect(() => {
    const nestedPropInputsValue = lastUpdatedNestedProp === null ? undefined : lastUpdatedNestedProp !== undefined ? inputs[lastUpdatedNestedProp] : undefined;
    const inputsValue = nestedPropInputsValue !== undefined ? `${nestedPropInputsValue?.[lastUpdated]}-${lastUpdatedNestedProp}` : inputs[lastUpdated];
    if (lastUpdated && inputs && `${lastUpdated}${inputsValue}` !== lastValue) {
      if (onFormChange) {
        onFormChange(useFormInstance, lastUpdated, lastUpdatedNestedProp);
      }

      if (props.onFormChanged) {
        props.onFormChanged(useFormInstance, lastUpdated, lastUpdatedNestedProp);
      }

      setLastValue(`${lastUpdated}${inputsValue}`);
    }
    else if (props.onInitLoad && !isFormInitLoaded && !lastUpdated) {
      props.onInitLoad(useFormInstance);
      setIsFormInitLoaded(true);
    }
  }, [useFormInstance.inputs]);

  const handleSubmitClick = async (
    {
      text,
      onSuccessFunc,
      actionName = "",
      actionHandleSubmit = undefined as any,
      actionSubmitSuffix = "",
      actionSubmitMethod = "",
      actionSuccessMessage = "",
      actionValidationFunc = undefined as any,
    }) => {
    if (props.handleSubmit || submitSuffix || actionSubmitSuffix || actionHandleSubmit) {
      const formErrors = validateForm();
      if (formErrors) {
        setErrors(formErrors);
      }
      else {
        setErrors({});
        const submitFunc = (submitOptions) => {
          const handleSubmitFunc = actionHandleSubmit || props.handleSubmit;
          if (handleSubmitFunc && typeof handleSubmitFunc === "function") {
            resetSubmittingStates();
            handleSubmitFunc(inputs, submitOptions);
          }
          else if (submitSuffix || actionSubmitSuffix) {
            const submitSuffixValue = actionSubmitSuffix || submitSuffix;
            const parsedSubmitSuffix = typeof submitSuffixValue === "function" ? submitSuffixValue({ ...useFormInstance, buttonText: text }) : submitSuffixValue;
            handleSubmit(parsedSubmitSuffix, {
              method: actionSubmitMethod || submitMethod,
              payloadDataType,
              buttonText: text,
              onSuccessFunc,
              useFormInstance,
              actionName,
              actionSuccessMessage
            } as IHandleSubmitOptions);
          }
        };

        const submitOptions = { ...useFormInstance, handleSubmit, onSuccessFunc, buttonText: text, setFormErrorMessage, useFormInstance, actionName, payloadDataType };
        if (actionValidationFunc || props.handleSubmitValidation) {
          initSubmittingStates(text);
          const handleSubmitValidation = actionValidationFunc || props.handleSubmitValidation;
          const { success, errorMessage, errorHeader } = await handleSubmitValidation(inputs, submitOptions);
          if (errorMessage && !success) {
            resetSubmittingStates();
            setFormErrorMessage({ message: errorMessage, header: errorHeader });
          }
          else {
            submitFunc(submitOptions);
          }
        }
        else {
          return submitFunc(submitOptions);
        }
      }

      return formErrors;
    }

    return true;
  };

  const handleFormClose = () => {
    if (props.onCloseClick) {
      props.onCloseClick(useFormInstance);
    }

    if (props.handleClose) {
      props.handleClose();
    }
    else if (exitEditOnClose) {
      if (!isDisabled) {
        setIsDisabled(true);
        resetForm();
      }
    }
    else {
      handleClose(props.onClosePath);
    }
  };

  const handleEditClick = () => {
    if (props.onEditClick) {
      props.onEditClick(useFormInstance);
    }

    setIsDisabled(false);
  };

  const handleActionClick = (action, text = "") => {
    if (action?.isIframeModal) {
      if (action?.path || action?.pathFunc) {
        const path = action?.path || action?.pathFunc({ ...useFormInstance });
        if (action?.modalSize) {
          setModalIframeSize(action?.modalSize);
        }

        if (action?.modalIframeHeight) {
          setModalIframeHeight(action?.modalIframeHeight);
        }

        if (path) {
          const parsedPath = appendIdToPath({ path });
          setModalIframeSrcPath(`${window.location.origin}${parsedPath}`);
        }
      }
    }
    else if (action.handleDownload) {
      action.handleDownload(handleDownloadFile, { ...useFormInstance, buttonText: text });
    }
    else if (action.path) {
      history.push(action.path);
    }
    else if (action.pathFunc) {
      history.push(action.pathFunc({ ...useFormInstance }));
    }
    else if (action.handleClick && typeof action.handleClick === "function") {
      action.handleClick(inputs, handleSubmit, { ...useFormInstance, buttonText: text });
    }

    return;
  };

  const handleDeleteClick = (action, text = "") => {
    if (deleteSuffix) {
      handleDelete(deleteSuffix, { method: "DELETE", buttonText: text, onSuccessFunc: handleFormClose } as any);
    }
    else if (action.handleDelete) {
      action.handleDelete(recordId);
    }
    else {
      return null;
    }
  };

  const handleFormChange = (e, data, type = undefined, onChange, onFieldChanged = null as any, nestedProp, charLimit = undefined as number | undefined) => {
    if (onChange) {
      onChange({ e, data, type, ...useFormInstance });
    }
    else {
      handleChange(e, data, type, nestedProp, onFieldChanged, charLimit);
    }
  };

  const handleButtonClick = (buttonAction, fieldProps) => {
    if (!buttonAction) {
      return;
    }
    else if (typeof buttonAction === "string") {
      return history.push(buttonAction);
    }
    else {
      buttonAction(fieldProps);
    }
  };

  const getEditButton = (formActions) => {
    for (const action of formActions) {
      const actionName = typeof action === "string" ? action : action.action ? action.action : action.text;
      const key = `${actionName}`;
      const textDictionary = {
        [GlobalConstants.FormDefaultAction.EDIT]: action?.text || "Edit",
      };

      const text = textDictionary[actionName] || action.text;
      const isActive = activeButtonText === text;
      const commonProps = { key, disabled: submitting, content: text, size: "small" as any, basic: true };
      if (actionName === GlobalConstants.FormDefaultAction.EDIT && isDisabled && !props.error && !submitting) {
        return <Form.Group className="lms-form-generator-submit-container" inline>
          <Button {...commonProps} loading={isActive && submitting} icon={GlobalConstants.Icons.EDIT} onClick={() => handleEditClick()}/>
        </Form.Group>;
      }
    }
  };

  const getFormActionButtons = (actions: FormActionsType, isTopAction = false) => {
    return <Form.Group className="lms-form-generator-submit-container" inline>
      <React.Fragment>
        {actions?.map((action, i) => {
          const actionName = typeof action === "string" ? action : action.action ? action.action : action.text;
          const key = `${actionName}${i}`;
          const textDictionary = {
            [GlobalConstants.FormDefaultAction.SAVE]: action?.text || "Save",
            [GlobalConstants.FormDefaultAction.SUBMIT]: action?.text || "Save",
            [GlobalConstants.FormDefaultAction.SAVE_CONTINUE]: action?.text || "Save and Continue",
            [GlobalConstants.FormDefaultAction.SAVE_CLOSE]: action?.text || "Save and Close",
            [GlobalConstants.FormDefaultAction.SAVE_NEW]: action?.text || "Save and New",
            [GlobalConstants.FormDefaultAction.DELETE]: action?.text || "Delete",
            [GlobalConstants.FormDefaultAction.CLOSE]: action?.text || "Close",
            [GlobalConstants.FormDefaultAction.EDIT]: action?.text || "Edit"
          };

          const text = textDictionary[actionName] || action.text;
          const onActionSuccess = action?.onSuccess;
          const submitConfirmationMessage = action?.submitConfirmationMessage || props.submitConfirmationMessage || props.myForm.submitConfirmationMessage || "";
          const defaultConfirmMessage = typeof submitConfirmationMessage === "function" ? submitConfirmationMessage({ ...useFormInstance }) : submitConfirmationMessage;
          const submitAlertMessage = action?.submitAlertMessage || props.submitAlertMessage || props.myForm.submitAlertMessage || "";
          const defaultAlertMessage = typeof submitAlertMessage === "function" ? submitAlertMessage({ ...useFormInstance }) : submitAlertMessage;
          const isActive = activeButtonText === text;
          const isLoading = activeButtonText === text && submitting;
          const isNegative = isActive && !!submitError;
          const isButtonDisabled = typeof action?.isDisabled === "function" ? action.isDisabled(isDisabled || submitting, useFormInstance) : submitting;
          const isButtonHidden = typeof action?.isHidden === "function" ? action.isHidden(isDisabled || submitting, useFormInstance) : action?.isHidden;
          const commonProps = { key, disabled: isButtonDisabled, content: text, size: "small" as any, basic: true };

          const handleSubmitConfirmFunc = (onSuccessFunc = onActionSuccess, confirmationMessage = defaultConfirmMessage, isAlert = false) => {
            handleConfirmFunc(() => handleSubmitClick({
                text,
                onSuccessFunc: onSuccessFunc,
                actionName,
                actionHandleSubmit: action?.actionHandleSubmit,
                actionSubmitSuffix: action?.actionSubmitSuffix,
                actionSubmitMethod: action?.actionSubmitMethod,
                actionSuccessMessage: action?.actionSuccessMessage,
                actionValidationFunc: action?.actionValidationFunc,
              }),
              confirmationMessage,
              isAlert
            );
          };

          if (["submit", "save", "save-continue"].includes(actionName) && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => handleSubmitConfirmFunc(onActionSuccess, defaultConfirmMessage || defaultAlertMessage, !!defaultAlertMessage)}
              className={action.className ? action.className : ""}
              positive={isActive && success}
              negative={isNegative}
              loading={isLoading}
              icon={action.icon || GlobalConstants.Icons.SAVE}
            />;
          }
          else if (actionName === GlobalConstants.FormDefaultAction.SAVE_CLOSE && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => handleSubmitConfirmFunc(handleFormClose, defaultConfirmMessage || defaultAlertMessage, !!defaultAlertMessage)}
              className={action.className ? action.className : ""}
              positive={isActive && success}
              negative={!!(isActive && submitError)}
              loading={isLoading}
              icon={GlobalConstants.Icons.SAVE}
            />;
          }
          else if (actionName === GlobalConstants.FormDefaultAction.SAVE_NEW && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => handleSubmitConfirmFunc(resetForm, defaultConfirmMessage || defaultAlertMessage, !!defaultAlertMessage)}
              className={action.className ? action.className : ""}
              positive={isActive && success}
              loading={isLoading}
              icon={GlobalConstants.Icons.SAVE}
            />;
          }
          else if (actionName === GlobalConstants.FormDefaultAction.DELETE && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => {
                handleConfirmFunc(() => handleDeleteClick(action, text),
                  "Are you sure you want to delete this record?"
                );
              }}
              className={action.className ? action.className : ""}
              positive={isActive && success}
              negative={!!(isActive && submitError)}
              loading={isLoading}
              icon={GlobalConstants.Icons.DELETE}
            />;
          }
          else if (actionName === GlobalConstants.FormDefaultAction.REFRESH) {
            return (
              <Button
                {...commonProps}
                onClick={() => resetForm()}
                className={action.className ? action.className : ""}
                positive={isActive && success}
                negative={!!(isActive && submitError)}
                loading={isLoading}
                icon={action.icon || GlobalConstants.Icons.CARET_UP}
              />
            );
          }
          else if (actionName === GlobalConstants.FormDefaultAction.CLOSE && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => {
                if (lastUpdated && Object.values(initialValues).join("") !== Object.values(inputs).join("")) {
                  handleConfirmFunc(handleFormClose,
                    "This page is asking you to confirm that you want to leave - data you have entered may not be saved."
                  );
                }
                else {
                  handleFormClose();
                }
              }}
              className={action.className ? action.className : ""}
              icon={GlobalConstants.Icons.CLOSE}
              loading={isLoading}
            />;
          }
          else if (actionName === GlobalConstants.FormDefaultAction.DOWNLOAD && !isButtonHidden) {
            return <Button
              {...commonProps}
              onClick={() => {
                const downloadPath = typeof action.path === "function" ? action.path(inputs, useFormInstance) : action.path;
                return handleDownloadFile(downloadPath, {
                  fileName: action.fileName || text,
                  method: action.method,
                  data: action.method === "POST" ? inputs : undefined
                }, text);
              }}
              className={action.className ? action.className : ""}
              icon={action.icon || GlobalConstants.Icons.CARET_UP}
              negative={!!(isActive && submitError)}
              loading={isLoading}
            />;
          }
          else if (isTopAction && actionName === GlobalConstants.FormDefaultAction.EDIT && isDisabled && !props.error && !submitting) {
            return <Button
                {...commonProps}
                loading={isLoading}
                icon={GlobalConstants.Icons.EDIT}
                onClick={() => handleEditClick()}
              />;
          }
          else if (typeof action === "object" && action.text && !isButtonHidden) {
            return <LmsButtonAction
              {...commonProps}
              handleButtonClick={() => handleActionClick(action, text)}
              className={action.className ? action.className : ""}
              negative={!!(isActive && submitError)}
              loading={isLoading}
              icon={action.icon}
              isDisabled={isButtonDisabled}
              useFormInstance={useFormInstance}
              modalContent={action.modalContent}
              modalSize={action.modalSize}
            />;
          }
          else return null;
        })}
      </React.Fragment>
    </Form.Group>;
  };

  const getIsTopActionsDisplayed = () => {
    if (!props.skipActions && props.topActions && props.topActions?.length > 0) {
      if (props.hideTopActionsOnEdit) {
        return isDisabled && !submitting;
      }

      return true;
    }
  };

  const getIsBottomActionsDisplayed = () => {
    if (!props.skipActions && formActions?.length > 0) {
      if (props.hideBottomActionsOnEdit || props.topActions) {
        return !isDisabled || submitting;
      }

      return true;
    }
  };

  const handleIframeLoad = () => {
    const iframeItem = iframeModalRef.current as any;
    if (iframeItem) {
      if (FeatureFlags.IS_DEBUG) {
        console.log(iframeItem?.contentWindow);
      }

      iframeItem?.contentWindow?.sessionStorage?.setItem("iframeTitle", modalIframeSrcPath); // TODO: Updated with needed functionality
      setModalIframeHeight(iframeItem.contentWindow.document.documentElement.scrollHeight); // TODO: Updated with needed functionality
    }
  };

  const errorToDisplay = props.error ? props.error : formErrorMessage ? formErrorMessage : undefined;
  const formContainerClassName = `${props.myForm.className || "lms-form-generator-container"}${lmsCustomFormStyles?.minWidth ? " lms-overflow-x-scroll" : ""}`;
  return <BCErrorBoundary>
    {errorToDisplay && (
      <LmsMessage
        text={errorToDisplay?.message}
        errorResponse={errorToDisplay?.errorResponse}
        header={errorToDisplay?.header}
        autoCloseIn={errorToDisplay?.skipAutoClose || props.skipErrorAutoClose ? 0 : errorToDisplay?.autoCloseIn || 5000}
        skipAutoClose={errorToDisplay?.skipAutoClose || props.skipErrorAutoClose}
        skipHeader={!!errorToDisplay?.skipHeader}
        onDismiss={() => {
          if (errorToDisplay?.onDismiss) {
            errorToDisplay.onDismiss();
          }
          else {
            setFormErrorMessage(undefined);
          }
        }}
      />
    )}
    {submitError && displayMessageLocally && <LmsMessage text={submitError.message} skipAutoClose={props.skipErrorAutoClose !== false} />}
    {formFields && <Card fluid className={`lms-form-generator-wrapper-card ${props.myForm.noBorder ? "no-border" : ""}`}>
      <div className={formContainerClassName}>
        {confirmOptions?.isOpen && <Confirm
          size="tiny"
          open={!!confirmOptions?.isOpen}
          onCancel={() => {
            setConfirmOptions({ isOpen: false });
            if (submitting && isDisabled) {
              resetSubmittingStates();
            }
          }}
          onConfirm={() => {
            if (confirmOptions?.func) {
              confirmOptions?.func();
            }

            if (submitting && isDisabled) {
              resetSubmittingStates();
            }

            setConfirmOptions({ isOpen: false });
          }}
          content={confirmOptions?.message || ""}
          confirmButton={confirmOptions?.confirmButtonText}
          className={confirmOptions?.isAlert ? "form-generator-alert-confirm" : ""}
        />}
        {!!modalIframeSrcPath && <BCModal
          isModalOpen
          size={modalIframeSize || props.iframeModalSize || "large"}
          closeIcon
          onClose={() => setModalIframeSrcPath("")}
          content={(
            <iframe
              ref={iframeModalRef}
              src={modalIframeSrcPath}
              width="100%"
              height={modalIframeHeight || props.iframeModalHeight || 600}
              style={{ border: "none" }}
              title="Iframe Test"
              onLoad={handleIframeLoad} />
          )}
        />}
        {label && <div className={props.myForm.labelClassName || "lms-form-generator-container-label"}>
          <div className="label">{label}</div>
        </div>}
        {centeredTitle && <div className="lms-form-generator-container-centered-label">
          <div className="label">{centeredTitle}</div>
        </div>}
        {errorTitle && <div className={props.myForm.errorTitleClassName || "lms-form-generator-container-error-label"}>
          <div className="error-label">{errorTitle}</div>
        </div>}
        <Form as={props.renderAs} loading={props.isLoading || isFormLoading} style={lmsCustomFormStyles}>
          {(!props.skipActions && !props.topActions && !!getEditButton(formActions)) && <> {getEditButton(formActions)}</>}
          {props.topActions && getIsTopActionsDisplayed() && <> {getFormActionButtons(props.topActions, true)}</>}
          {!props.onlyActions && formFields?.map((fo, index) => {
            const nestedValue = getNestedValue(fo);
            const isRequired = fo.required === true || validations?.[fo.name]?.required === true || (Array.isArray(validations?.[fo.name]) && validations?.[fo.name]?.includes("required"));
            const fieldProps = {
              ...useFormInstance,
              handleChange: (e, data, type) => handleFormChange(e, data, type, fo.onChange, fo.onFieldChanged, fo.nestedInputsProp, fo.charLimit),
              onBlur: props.onBlur,
              displayValues,
              key: `group-field-option-${index}`,
              options: fo,
              fieldClassName: fo.fieldClassName || props.myForm.fieldClassName,
              labelClassName: fo.fieldLabelClassName || props.myForm.fieldLabelClassName,
              isDisabled: useFormInstance?.isDisabled || fo.disabled || handleIsDisabled(fo),
              isRequired: isRequired || getFieldHasValidation({ name: fo.name, validationName: "required", formValidations: validations, useFormOptions: useFormInstance, inputs }),
              isActionHidden: fo.isActionHiddenOnDisabled && isDisabled,
              isActionEnabled: fo.isActionEnabled && !useFormInstance?.isDisabled,
              useFormInstance,
              fileDownloads,
              isCompact: fo.isCompact || isCompact,
              dropdownOptionsData: allDropdownOptionsData,
              isLoading: allDropdownOptionsIsLoading && !!fo.dropdownOptionsIsPromiseAll,
              isPromiseAll: !!fo.dropdownOptionsIsPromiseAll,
            };

            if (handleIsHidden(fo)) {
              if (fo.keepHiddenPosition) {
                return <Form.Field
                  key={`hidden-group-blank-field-${index}`}
                  width={fo.width}
                  children={[
                    <div key={`hidden-group-blank-field-child-${index}`}></div>,
                  ]}
                />;
              }
              else {
                return <React.Fragment key={`hidden-fragment-group-${index}`} />;
              }
            }

            if (fo.field === "warningText") {
              return <Form.Field
                key={`hidden-group-blank-field-${index}`}
                width={fo.width}
                children={[
                  (
                    <div
                      key={`group-warning-text-field-child-${index}`}
                      style={{ color: fo.valueColor || "red", fontSize: fo.fontSize || "1.2em", fontWeight: fo.fontWeight || 500 }}
                      className="lms-flex-centered-container-compact"
                    >
                      {fo.warningFieldText}
                    </div>
                  ),
                ]}
              />;
            }

            if (fo.component) {
              if (props.componentProps && fo.name in props.componentProps) {
                const { component: Component, name } = fo;

                return (
                  <Form.Field
                    key={`component-field-${index}`}
                    width={fo.width}
                    className="lms-form-component-field-container"
                  >
                    <Component {...props.componentProps[name]} />
                  </Form.Field>
                );
              }
              if (typeof fo.component === "function") {
                return <Form.Field
                  key={`component-field-${index}`}
                  width={fo.width}
                  className="lms-form-component-field-container"
                  children={[fo.component(fieldProps)]}
                />;
              }

              return <Form.Field
                key={`component-field-${index}`}
                className="lms-form-component-field-container"
                children={[fo.component]}
              />;
            }

            if (fo.isDivider) {
              if (fo.dividerText) {
                return <Divider horizontal key={`group-field-divider-${index}`} hidden={fo.dividerIsHidden}>{fo.dividerText}</Divider>;
              }
              else {
                return <Divider key={`group-field-divider-${index}`} hidden={fo.dividerIsHidden} />;
              }
            }

            if (fo.groupFields && !(fo.isHidden && handleIsHidden(fo))) {
              return <Form.Group
                key={`group-key-${index}`}
                widths={fo.widths || "equal"}
                inline={!!fo.inlineGroup}
                className={`${fo.groupClassName || props.myForm.groupClassName || ""}${isCompact || fo.isCompact ? " lms-form-compact-group" : ""}`}
                style={fo.groupStyles || props.myForm.groupStyles}
              >
                {fo.groupLabel && <label>{fo.groupLabel}</label>}
                {fo.groupFields.map((o: any, i) => {
                  const nestedValue = getNestedValue(o);
                  const fieldIsRequired = o.required === true || validations?.[o.name]?.required === true || (Array.isArray(validations?.[o.name]) && validations?.[o.name]?.includes("required"));
                  const groupFieldProps = {
                    ...useFormInstance,
                    handleChange: (e, data, type) => handleFormChange(e, data, type, o.onChange, o.onFieldChanged, o.nestedInputsProp, o.charLimit),
                    onBlur: props.onBlur,
                    displayValues,
                    key: `group-field-option-${i}`,
                    options: o,
                    fieldClassName: o.fieldClassName || props.myForm.fieldClassName,
                    labelClassName: o.fieldLabelClassName || props.myForm.fieldLabelClassName,
                    isDisabled: useFormInstance?.isDisabled || o.disabled || handleIsDisabled(o),
                    isRequired: fieldIsRequired || getFieldHasValidation({ name: o.name, validationName: "required", formValidations: validations, useFormOptions: useFormInstance, inputs }),
                    isActionHidden: o.isActionHiddenOnDisabled && isDisabled,
                    isActionEnabled: o.isActionEnabled && !useFormInstance?.isDisabled,
                    useFormInstance,
                    fileDownloads,
                    isCompact: o.isCompact || isCompact,
                    dropdownOptionsData: allDropdownOptionsData,
                    isLoading: allDropdownOptionsIsLoading && !!o.dropdownOptionsIsPromiseAll,
                    isPromiseAll: !!o.dropdownOptionsIsPromiseAll,
                    dropdownSkipCache: o.dropdownSkipCache,
                  };

                  if (handleIsHidden(o)) {
                    if (o.keepHiddenPosition) {
                      return <Form.Field
                        key={`hidden-group-blank-field-${i}`}
                        width={o.width}
                        children={[
                          <div key={`hidden-group-blank-field-child-${i}`}></div>,
                        ]}
                      />;
                    }
                    else {
                      return <React.Fragment key={`hidden-fragment-group-${i}`} />;
                    }
                  }
                  else if(o.field === "warningText") {
                    return <Form.Field
                      key={`hidden-group-blank-field-${i}`}
                      width={o.width}
                      children={[
                        (
                          <div
                            key={`group-warning-text-field-child-${i}`}
                            style={{ color: fo.valueColor || "red", fontSize: fo.fontSize || "1.2em", fontWeight: fo.fontWeight || 500 }}
                            className="lms-flex-centered-container-compact"
                          >
                            {o.warningFieldText}
                          </div>
                        ),
                      ]}
                    />;
                  }
                  else if (o.component) {
                    if (props.componentProps && o.name in props.componentProps) {
                      const { component: Component, name } = o;

                      return (
                        <Form.Field
                          key={`component-field-${i}`}
                          width={o.width}
                          className="lms-form-component-field-container"
                        >
                          <Component {...props.componentProps[name]} />
                        </Form.Field>
                      );
                    }
                    if (typeof o.component === "function") {
                      return <Form.Field
                        key={`component-field-${i}`}
                        width={o.width}
                        className="lms-form-component-field-container"
                        children={[o.component(fieldProps)]}
                      />;
                    }

                    return <Form.Field
                      key={`component-field-${i}`}
                      width={o.width}
                      className="lms-form-component-field-container"
                      children={[o.component]}
                    />;
                  }
                  else if (o.field === "button") {
                    return <LmsButtonField
                      key={`button-group-field-${i}`}
                      fieldOptions={o}
                      buttonText={o.value}
                      isDisabled={groupFieldProps.isDisabled && !o.isEnabled}
                      handleButtonClick={() => handleButtonClick(o.onButtonClick, groupFieldProps)}
                      useFormInstance={useFormInstance}
                      modalContent={o.modalContent}
                      modalSize={o.modalSize}
                      buttonRenderType={o.buttonRenderType}
                    />;
                  }
                  else if (o.field === "buttonsGroup") {
                    return <Form.Field
                      key={`buttons-group-field-${i}`}
                      width={o.width}
                      className="lms-flex-centered-row-container flex-gap-5"
                      children={[...(o.buttonsGroup.map((bo: any, i: number) => {
                        return <LmsButtonField
                          key={`button-group-field-${i}`}
                          fieldOptions={bo}
                          buttonText={bo.value}
                          isDisabled={groupFieldProps.isDisabled && !bo.isEnabled}
                          handleButtonClick={() => handleButtonClick(bo.onButtonClick, groupFieldProps)}
                          useFormInstance={useFormInstance}
                          modalContent={bo.modalContent}
                          modalSize={bo.modalSize}
                          buttonRenderType={bo.buttonRenderType}
                        />;
                      }))]}
                    />;
                  }
                  else if (o.field === "blank") {
                    return <Form.Field
                      key={`radio-group-blank-field-${i}`}
                      width={o.width}
                      children={[
                        <div key={`radio-group-blank-div-${i}`}></div>,
                      ]}
                    />;
                  }
                  else if (o.field === "radio") {
                    return <Form.Radio
                      key={`radio-group-filed-${o.value}`}
                      label={o.label}
                      value={o.value}
                      checked={inputs[fo.radioGroupName] === o.value}
                      onChange={handleChange}
                      name={fo.radioGroupName}
                      error={errors[fo.radioGroupName] as any}
                      disabled={isDisabled || handleIsDisabled({ ...o, name: fo.radioGroupName })}
                      required={o.required}
                    />;
                  }
                  else if (o.field === "list") {
                    const values = inputs[o.name] || o.value;
                    const listItemType = o.listItemType || "Link";
                    if (values) {
                      return <Form.Field
                        key={`list-field-${i}`}
                        width={o.width}
                        children={[
                          <List>
                            {values.map((listOption, i) => {
                              const linkName = typeof listOption === "string" ? listOption : listOption?.linkName || listOption?.link;
                              const content = listOption.text || listOption?.contentComponent || <a onClick={() => o.handleClick(listOption)}>{linkName}</a>;
                              return <List.Item
                                key={`list-field-option${i}`}
                                icon={listOption?.listItemIcon ? listOption?.listItemIcon : !listOption.text ? o.listItemIcon : undefined}
                                content={listItemType === "Text" && typeof listOption === "string" ? listOption : content}
                              />;
                            })}
                          </List>
                        ]}
                      />;
                    }
                  }
                  else if (o.field === "dropdown") {
                    return <LmsFormDropdownField {...groupFieldProps} value={nestedValue} />;
                  }
                  else {
                    return <LmsFormField {...groupFieldProps} value={nestedValue} />;
                  }
                })}
              </Form.Group>;
            }
            else if (fo.field === "button") {
              return <LmsButtonField
                fieldOptions={fo}
                buttonText={fo.value || nestedValue || inputs[fo.name]}
                isDisabled={fieldProps.isDisabled}
                handleButtonClick={() => handleButtonClick(fo.onButtonClick, fieldProps)}
                useFormInstance={useFormInstance}
                modalContent={fo.modalContent}
                modalSize={fo.modalSize}
                buttonRenderType={fo.buttonRenderType}
              />;
            }
            else if (fo.field === "dropdown") {
              return <LmsFormDropdownField {...fieldProps} value={nestedValue} />;
            }
            else {
              return <LmsFormField {...fieldProps} value={nestedValue} />;
            }
          })}
          {getIsBottomActionsDisplayed() && getFormActionButtons(formActions as FormActionsType)}
        </Form>
      </div>
    </Card>}
  </BCErrorBoundary>;
};

export default LmsFormGenerator;